<script setup lang="ts">
import type { SelectItemProps } from 'reka-ui'
import { SelectItem, SelectItemIndicator, SelectItemText } from 'reka-ui'
import { faCheck } from '@fortawesome/duotone-regular-svg-icons'

const props = defineProps<SelectItemProps>()
</script>

<template>
  <SelectItem v-bind="props">
    <SelectItemText class="line-clamp-1">
      <slot />
    </SelectItemText>
    <SelectItemIndicator>
      <font-awesome-icon :icon="faCheck" />
    </SelectItemIndicator>
  </SelectItem>
</template>
